<div class="analysis-options ac-modal dialog-width">
	<div class="header">
		<h3 class="text-align-center text-16-bold margin-bottom-10" dcrHTMLKey="SCENARIO_POPUP_TITLE">Change/Add Sample Scenarios</h3>
	</div>

	<div class="content larger" *ngIf="this.data; else noData">
		<div class="scenario-checkboxes">
			<div class="scenarios wrap">
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<sc-scenario
					*ngFor="let scenario of allScenarios"
					[scenario]="scenario"
					[isSelected]="isSelected(scenario.rawValue)"
					[showInfoBubbles]="true"
					(onSelect)="selectScenario(scenario.rawValue)"
					(onDeselect)="deselectScenario(scenario.rawValue)"
				>
				</sc-scenario>
			</div>
		</div>
	</div>
	<div class="actions footer clearfix">
		<div class="button-actions d-flex">
			<button
				dz-button
				color="secondary"
				class="dialog-button"
				custom-tracking
				track-event="scenarios:simple-scenario-selection-dialog:button:cancel"
				(click)="closeScenarios()"
			>
				Cancel
			</button>
			<button dz-button class="dialog-button" (click)="saveScenarios()" [disabled]="!this.data || selectedScenarioKeys.length < 1" cdkFocusInitial>Save</button>
		</div>
	</div>
</div>

<ng-template #noData class="scenarios">
	<p class="text-align-center padding-20 text-14 margin-bottom-10" dcrHTMLKey="NO_SCENARIO_RESULTS_TITLE">There are no scenarios to display</p>
</ng-template>
